import { render, staticRenderFns } from "./PopupHelp.vue?vue&type=template&id=00f65e60&scoped=true&"
import script from "./PopupHelp.vue?vue&type=script&lang=js&"
export * from "./PopupHelp.vue?vue&type=script&lang=js&"
import style0 from "./PopupHelp.vue?vue&type=style&index=0&id=00f65e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f65e60",
  null
  
)

export default component.exports